import React from 'react'

export default function CalanderSkelton() {
    return (
        <div className="border border-gray-200 bg-white rounded-2xl p-4 shadow-sm">
            <div className="monthname flex justify-between items-center mb-3">
                {/* Skeleton for Month Name */}
                <div className="h-6 w-20 bg-gray-200 rounded animate-pulse"></div>

                {/* Skeleton for Hijri Month Name */}
                <div className="h-6 w-28 bg-gray-200 rounded animate-pulse"></div>
            </div>

            {/* Skeleton for Weekday Headers */}
            <div className="grid grid-cols-7 gap-1 text-center text-sm mb-2">
                {Array.from({ length: 7 }).map((_, idx) => (
                    <div key={idx} className="h-4 w-full bg-gray-200 rounded animate-pulse"></div>
                ))}
            </div>

            {/* Skeleton for Calendar Days */}
            <div className="grid grid-cols-7 gap-1 text-center text-sm">
                {Array.from({ length: 35 }).map((_, dayIndex) => (
                    <div
                        key={dayIndex}
                        className="h-11 sm:h-12 bg-gray-100 rounded-lg animate-pulse"
                    >
                    </div>
                ))}
            </div>
        </div>
    )
}
